import { TokenProvider } from '~/hooks/auth/useAccessTokenProvider';
import { BackendClient } from './backend-client';
import { APIType } from './types';

export class DoseClient extends BackendClient {
    constructor(
        baseURL: string,
        tokenprovider: TokenProvider,
        sessionID: string
    ) {
        super(baseURL, tokenprovider, sessionID, APIType.DOSE);
    }
}
